/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_mailbox",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "_destinationDomain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_ism",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "_lZEndpoint",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "HookSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "IsmSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "destinationDomain",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "eid",
                        type: "uint32",
                    },
                    {
                        internalType: "address",
                        name: "refundAddress",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "options",
                        type: "bytes",
                    },
                ],
                internalType: "struct LayerZeroV2Metadata",
                name: "layerZeroMetadata",
                type: "tuple",
            },
        ],
        name: "formatLzMetadata",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "hook",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hookType",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "interchainSecurityModule",
        outputs: [
            {
                internalType: "contract IInterchainSecurityModule",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ism",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lZEndpoint",
        outputs: [
            {
                internalType: "contract ILayerZeroEndpointV2",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "localDomain",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mailbox",
        outputs: [
            {
                internalType: "contract IMailbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "lZMetadata",
                type: "bytes",
            },
        ],
        name: "parseLzMetadata",
        outputs: [
            {
                internalType: "uint32",
                name: "eid",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "refundAddress",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "options",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "postDispatch",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "quoteDispatch",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "setHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "setInterchainSecurityModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
        ],
        name: "supportsMetadata",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class LayerZeroV2Hook__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_mailbox, _destinationDomain, _ism, _lZEndpoint, overrides) {
        return super.deploy(_mailbox, _destinationDomain, _ism, _lZEndpoint, overrides || {});
    }
    getDeployTransaction(_mailbox, _destinationDomain, _ism, _lZEndpoint, overrides) {
        return super.getDeployTransaction(_mailbox, _destinationDomain, _ism, _lZEndpoint, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=LayerZeroV2Hook__factory.js.map